module.exports = __webpack_public_path__ + "img/pico.40a7f61b.svg";